import { useMemo as Ae, useRef as Ee, useEffect as b, useState as Se } from "react";
import { useLocation as ve } from "react-router-dom";
import "react/jsx-runtime";
import { initReactI18next as _e } from "react-i18next";
import Ne from "i18next";
import xe from "i18next-icu";
const we = 2 ** 31 - 1;
function Ie(g, w) {
  const O = Ae(
    () => w && w > we ? we : w,
    [w]
  ), S = Ee(g);
  b(() => {
    S.current = g;
  }, [g]), b(() => {
    if (O === null)
      return;
    const p = setTimeout(() => S.current(), O);
    return () => clearTimeout(p);
  }, [O]);
}
const Fe = ({ endDate: g }) => {
  const [w, O] = Se(!1), S = Ee(null);
  return b(() => {
    if (g && !w) {
      const p = g.getTime(), P = Date.now(), _ = p - P;
      _ > 0 ? (O(!1), S.current = _) : O(!0);
    } else
      S.current = null;
  }, [g, w]), Ie(() => O(!0), S.current), w;
}, Ge = () => {
  const { pathname: g } = ve();
  b(() => {
    window.scrollTo(0, 0);
  }, [g]);
};
var Te = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, ae = Math.ceil, q = Math.floor, U = "[BigNumber Error] ", me = U + "Number primitive has more than 15 significant digits: ", z = 1e14, N = 14, he = 9007199254740991, pe = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], J = 1e7, D = 1e9;
function Oe(g) {
  var w, O, S, p = h.prototype = { constructor: h, toString: null, valueOf: null }, P = new h(1), _ = 20, I = 4, C = -7, k = 21, Q = -1e7, $ = 1e7, Z = !1, ee = 1, Y = 0, fe = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, K = "0123456789abcdefghijklmnopqrstuvwxyz", oe = !0;
  function h(e, r) {
    var n, l, t, o, c, i, f, u, s = this;
    if (!(s instanceof h)) return new h(e, r);
    if (r == null) {
      if (e && e._isBigNumber === !0) {
        s.s = e.s, !e.c || e.e > $ ? s.c = s.e = null : e.e < Q ? s.c = [s.e = 0] : (s.e = e.e, s.c = e.c.slice());
        return;
      }
      if ((i = typeof e == "number") && e * 0 == 0) {
        if (s.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
          for (o = 0, c = e; c >= 10; c /= 10, o++) ;
          o > $ ? s.c = s.e = null : (s.e = o, s.c = [e]);
          return;
        }
        u = String(e);
      } else {
        if (!Te.test(u = String(e))) return S(s, u, i);
        s.s = u.charCodeAt(0) == 45 ? (u = u.slice(1), -1) : 1;
      }
      (o = u.indexOf(".")) > -1 && (u = u.replace(".", "")), (c = u.search(/e/i)) > 0 ? (o < 0 && (o = c), o += +u.slice(c + 1), u = u.substring(0, c)) : o < 0 && (o = u.length);
    } else {
      if (x(r, 2, K.length, "Base"), r == 10 && oe)
        return s = new h(e), F(s, _ + s.e + 1, I);
      if (u = String(e), i = typeof e == "number") {
        if (e * 0 != 0) return S(s, u, i, r);
        if (s.s = 1 / e < 0 ? (u = u.slice(1), -1) : 1, h.DEBUG && u.replace(/^0\.0*|\./, "").length > 15)
          throw Error(me + e);
      } else
        s.s = u.charCodeAt(0) === 45 ? (u = u.slice(1), -1) : 1;
      for (n = K.slice(0, r), o = c = 0, f = u.length; c < f; c++)
        if (n.indexOf(l = u.charAt(c)) < 0) {
          if (l == ".") {
            if (c > o) {
              o = f;
              continue;
            }
          } else if (!t && (u == u.toUpperCase() && (u = u.toLowerCase()) || u == u.toLowerCase() && (u = u.toUpperCase()))) {
            t = !0, c = -1, o = 0;
            continue;
          }
          return S(s, String(e), i, r);
        }
      i = !1, u = O(u, r, 10, s.s), (o = u.indexOf(".")) > -1 ? u = u.replace(".", "") : o = u.length;
    }
    for (c = 0; u.charCodeAt(c) === 48; c++) ;
    for (f = u.length; u.charCodeAt(--f) === 48; ) ;
    if (u = u.slice(c, ++f)) {
      if (f -= c, i && h.DEBUG && f > 15 && (e > he || e !== q(e)))
        throw Error(me + s.s * e);
      if ((o = o - c - 1) > $)
        s.c = s.e = null;
      else if (o < Q)
        s.c = [s.e = 0];
      else {
        if (s.e = o, s.c = [], c = (o + 1) % N, o < 0 && (c += N), c < f) {
          for (c && s.c.push(+u.slice(0, c)), f -= N; c < f; )
            s.c.push(+u.slice(c, c += N));
          c = N - (u = u.slice(c)).length;
        } else
          c -= f;
        for (; c--; u += "0") ;
        s.c.push(+u);
      }
    } else
      s.c = [s.e = 0];
  }
  h.clone = Oe, h.ROUND_UP = 0, h.ROUND_DOWN = 1, h.ROUND_CEIL = 2, h.ROUND_FLOOR = 3, h.ROUND_HALF_UP = 4, h.ROUND_HALF_DOWN = 5, h.ROUND_HALF_EVEN = 6, h.ROUND_HALF_CEIL = 7, h.ROUND_HALF_FLOOR = 8, h.EUCLID = 9, h.config = h.set = function(e) {
    var r, n;
    if (e != null)
      if (typeof e == "object") {
        if (e.hasOwnProperty(r = "DECIMAL_PLACES") && (n = e[r], x(n, 0, D, r), _ = n), e.hasOwnProperty(r = "ROUNDING_MODE") && (n = e[r], x(n, 0, 8, r), I = n), e.hasOwnProperty(r = "EXPONENTIAL_AT") && (n = e[r], n && n.pop ? (x(n[0], -D, 0, r), x(n[1], 0, D, r), C = n[0], k = n[1]) : (x(n, -D, D, r), C = -(k = n < 0 ? -n : n))), e.hasOwnProperty(r = "RANGE"))
          if (n = e[r], n && n.pop)
            x(n[0], -D, -1, r), x(n[1], 1, D, r), Q = n[0], $ = n[1];
          else if (x(n, -D, D, r), n)
            Q = -($ = n < 0 ? -n : n);
          else
            throw Error(U + r + " cannot be zero: " + n);
        if (e.hasOwnProperty(r = "CRYPTO"))
          if (n = e[r], n === !!n)
            if (n)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                Z = n;
              else
                throw Z = !n, Error(U + "crypto unavailable");
            else
              Z = n;
          else
            throw Error(U + r + " not true or false: " + n);
        if (e.hasOwnProperty(r = "MODULO_MODE") && (n = e[r], x(n, 0, 9, r), ee = n), e.hasOwnProperty(r = "POW_PRECISION") && (n = e[r], x(n, 0, D, r), Y = n), e.hasOwnProperty(r = "FORMAT"))
          if (n = e[r], typeof n == "object") fe = n;
          else throw Error(U + r + " not an object: " + n);
        if (e.hasOwnProperty(r = "ALPHABET"))
          if (n = e[r], typeof n == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(n))
            oe = n.slice(0, 10) == "0123456789", K = n;
          else
            throw Error(U + r + " invalid: " + n);
      } else
        throw Error(U + "Object expected: " + e);
    return {
      DECIMAL_PLACES: _,
      ROUNDING_MODE: I,
      EXPONENTIAL_AT: [C, k],
      RANGE: [Q, $],
      CRYPTO: Z,
      MODULO_MODE: ee,
      POW_PRECISION: Y,
      FORMAT: fe,
      ALPHABET: K
    };
  }, h.isBigNumber = function(e) {
    if (!e || e._isBigNumber !== !0) return !1;
    if (!h.DEBUG) return !0;
    var r, n, l = e.c, t = e.e, o = e.s;
    e: if ({}.toString.call(l) == "[object Array]") {
      if ((o === 1 || o === -1) && t >= -D && t <= D && t === q(t)) {
        if (l[0] === 0) {
          if (t === 0 && l.length === 1) return !0;
          break e;
        }
        if (r = (t + 1) % N, r < 1 && (r += N), String(l[0]).length == r) {
          for (r = 0; r < l.length; r++)
            if (n = l[r], n < 0 || n >= z || n !== q(n)) break e;
          if (n !== 0) return !0;
        }
      }
    } else if (l === null && t === null && (o === null || o === 1 || o === -1))
      return !0;
    throw Error(U + "Invalid BigNumber: " + e);
  }, h.maximum = h.max = function() {
    return ge(arguments, -1);
  }, h.minimum = h.min = function() {
    return ge(arguments, 1);
  }, h.random = (function() {
    var e = 9007199254740992, r = Math.random() * e & 2097151 ? function() {
      return q(Math.random() * e);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(n) {
      var l, t, o, c, i, f = 0, u = [], s = new h(P);
      if (n == null ? n = _ : x(n, 0, D), c = ae(n / N), Z)
        if (crypto.getRandomValues) {
          for (l = crypto.getRandomValues(new Uint32Array(c *= 2)); f < c; )
            i = l[f] * 131072 + (l[f + 1] >>> 11), i >= 9e15 ? (t = crypto.getRandomValues(new Uint32Array(2)), l[f] = t[0], l[f + 1] = t[1]) : (u.push(i % 1e14), f += 2);
          f = c / 2;
        } else if (crypto.randomBytes) {
          for (l = crypto.randomBytes(c *= 7); f < c; )
            i = (l[f] & 31) * 281474976710656 + l[f + 1] * 1099511627776 + l[f + 2] * 4294967296 + l[f + 3] * 16777216 + (l[f + 4] << 16) + (l[f + 5] << 8) + l[f + 6], i >= 9e15 ? crypto.randomBytes(7).copy(l, f) : (u.push(i % 1e14), f += 7);
          f = c / 7;
        } else
          throw Z = !1, Error(U + "crypto unavailable");
      if (!Z)
        for (; f < c; )
          i = r(), i < 9e15 && (u[f++] = i % 1e14);
      for (c = u[--f], n %= N, c && n && (i = pe[N - n], u[f] = q(c / i) * i); u[f] === 0; u.pop(), f--) ;
      if (f < 0)
        u = [o = 0];
      else {
        for (o = -1; u[0] === 0; u.splice(0, 1), o -= N) ;
        for (f = 1, i = u[0]; i >= 10; i /= 10, f++) ;
        f < N && (o -= N - f);
      }
      return s.e = o, s.c = u, s;
    };
  })(), h.sum = function() {
    for (var e = 1, r = arguments, n = new h(r[0]); e < r.length; ) n = n.plus(r[e++]);
    return n;
  }, O = /* @__PURE__ */ (function() {
    var e = "0123456789";
    function r(n, l, t, o) {
      for (var c, i = [0], f, u = 0, s = n.length; u < s; ) {
        for (f = i.length; f--; i[f] *= l) ;
        for (i[0] += o.indexOf(n.charAt(u++)), c = 0; c < i.length; c++)
          i[c] > t - 1 && (i[c + 1] == null && (i[c + 1] = 0), i[c + 1] += i[c] / t | 0, i[c] %= t);
      }
      return i.reverse();
    }
    return function(n, l, t, o, c) {
      var i, f, u, s, a, m, E, A, T = n.indexOf("."), R = _, d = I;
      for (T >= 0 && (s = Y, Y = 0, n = n.replace(".", ""), A = new h(l), m = A.pow(n.length - T), Y = s, A.c = r(
        W(y(m.c), m.e, "0"),
        10,
        t,
        e
      ), A.e = A.c.length), E = r(n, l, t, c ? (i = K, e) : (i = e, K)), u = s = E.length; E[--s] == 0; E.pop()) ;
      if (!E[0]) return i.charAt(0);
      if (T < 0 ? --u : (m.c = E, m.e = u, m.s = o, m = w(m, A, R, d, t), E = m.c, a = m.r, u = m.e), f = u + R + 1, T = E[f], s = t / 2, a = a || f < 0 || E[f + 1] != null, a = d < 4 ? (T != null || a) && (d == 0 || d == (m.s < 0 ? 3 : 2)) : T > s || T == s && (d == 4 || a || d == 6 && E[f - 1] & 1 || d == (m.s < 0 ? 8 : 7)), f < 1 || !E[0])
        n = a ? W(i.charAt(1), -R, i.charAt(0)) : i.charAt(0);
      else {
        if (E.length = f, a)
          for (--t; ++E[--f] > t; )
            E[f] = 0, f || (++u, E = [1].concat(E));
        for (s = E.length; !E[--s]; ) ;
        for (T = 0, n = ""; T <= s; n += i.charAt(E[T++])) ;
        n = W(n, u, i.charAt(0));
      }
      return n;
    };
  })(), w = /* @__PURE__ */ (function() {
    function e(l, t, o) {
      var c, i, f, u, s = 0, a = l.length, m = t % J, E = t / J | 0;
      for (l = l.slice(); a--; )
        f = l[a] % J, u = l[a] / J | 0, c = E * f + u * m, i = m * f + c % J * J + s, s = (i / o | 0) + (c / J | 0) + E * u, l[a] = i % o;
      return s && (l = [s].concat(l)), l;
    }
    function r(l, t, o, c) {
      var i, f;
      if (o != c)
        f = o > c ? 1 : -1;
      else
        for (i = f = 0; i < o; i++)
          if (l[i] != t[i]) {
            f = l[i] > t[i] ? 1 : -1;
            break;
          }
      return f;
    }
    function n(l, t, o, c) {
      for (var i = 0; o--; )
        l[o] -= i, i = l[o] < t[o] ? 1 : 0, l[o] = i * c + l[o] - t[o];
      for (; !l[0] && l.length > 1; l.splice(0, 1)) ;
    }
    return function(l, t, o, c, i) {
      var f, u, s, a, m, E, A, T, R, d, v, M, ne, ue, ce, H, re, G = l.s == t.s ? 1 : -1, L = l.c, B = t.c;
      if (!L || !L[0] || !B || !B[0])
        return new h(
          // Return NaN if either NaN, or both Infinity or 0.
          !l.s || !t.s || (L ? B && L[0] == B[0] : !B) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            L && L[0] == 0 || !B ? G * 0 : G / 0
          )
        );
      for (T = new h(G), R = T.c = [], u = l.e - t.e, G = o + u + 1, i || (i = z, u = X(l.e / N) - X(t.e / N), G = G / N | 0), s = 0; B[s] == (L[s] || 0); s++) ;
      if (B[s] > (L[s] || 0) && u--, G < 0)
        R.push(1), a = !0;
      else {
        for (ue = L.length, H = B.length, s = 0, G += 2, m = q(i / (B[0] + 1)), m > 1 && (B = e(B, m, i), L = e(L, m, i), H = B.length, ue = L.length), ne = H, d = L.slice(0, H), v = d.length; v < H; d[v++] = 0) ;
        re = B.slice(), re = [0].concat(re), ce = B[0], B[1] >= i / 2 && ce++;
        do {
          if (m = 0, f = r(B, d, H, v), f < 0) {
            if (M = d[0], H != v && (M = M * i + (d[1] || 0)), m = q(M / ce), m > 1)
              for (m >= i && (m = i - 1), E = e(B, m, i), A = E.length, v = d.length; r(E, d, A, v) == 1; )
                m--, n(E, H < A ? re : B, A, i), A = E.length, f = 1;
            else
              m == 0 && (f = m = 1), E = B.slice(), A = E.length;
            if (A < v && (E = [0].concat(E)), n(d, E, v, i), v = d.length, f == -1)
              for (; r(B, d, H, v) < 1; )
                m++, n(d, H < v ? re : B, v, i), v = d.length;
          } else f === 0 && (m++, d = [0]);
          R[s++] = m, d[0] ? d[v++] = L[ne] || 0 : (d = [L[ne]], v = 1);
        } while ((ne++ < ue || d[0] != null) && G--);
        a = d[0] != null, R[0] || R.splice(0, 1);
      }
      if (i == z) {
        for (s = 1, G = R[0]; G >= 10; G /= 10, s++) ;
        F(T, o + (T.e = s + u * N - 1) + 1, c, a);
      } else
        T.e = u, T.r = +a;
      return T;
    };
  })();
  function se(e, r, n, l) {
    var t, o, c, i, f;
    if (n == null ? n = I : x(n, 0, 8), !e.c) return e.toString();
    if (t = e.c[0], c = e.e, r == null)
      f = y(e.c), f = l == 1 || l == 2 && (c <= C || c >= k) ? te(f, c) : W(f, c, "0");
    else if (e = F(new h(e), r, n), o = e.e, f = y(e.c), i = f.length, l == 1 || l == 2 && (r <= o || o <= C)) {
      for (; i < r; f += "0", i++) ;
      f = te(f, o);
    } else if (r -= c + (l === 2 && o > c), f = W(f, o, "0"), o + 1 > i) {
      if (--r > 0) for (f += "."; r--; f += "0") ;
    } else if (r += o - i, r > 0)
      for (o + 1 == i && (f += "."); r--; f += "0") ;
    return e.s < 0 && t ? "-" + f : f;
  }
  function ge(e, r) {
    for (var n, l, t = 1, o = new h(e[0]); t < e.length; t++)
      l = new h(e[t]), (!l.s || (n = j(o, l)) === r || n === 0 && o.s === r) && (o = l);
    return o;
  }
  function le(e, r, n) {
    for (var l = 1, t = r.length; !r[--t]; r.pop()) ;
    for (t = r[0]; t >= 10; t /= 10, l++) ;
    return (n = l + n * N - 1) > $ ? e.c = e.e = null : n < Q ? e.c = [e.e = 0] : (e.e = n, e.c = r), e;
  }
  S = /* @__PURE__ */ (function() {
    var e = /^(-?)0([xbo])(?=\w[\w.]*$)/i, r = /^([^.]+)\.$/, n = /^\.([^.]+)$/, l = /^-?(Infinity|NaN)$/, t = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(o, c, i, f) {
      var u, s = i ? c : c.replace(t, "");
      if (l.test(s))
        o.s = isNaN(s) ? null : s < 0 ? -1 : 1;
      else {
        if (!i && (s = s.replace(e, function(a, m, E) {
          return u = (E = E.toLowerCase()) == "x" ? 16 : E == "b" ? 2 : 8, !f || f == u ? m : a;
        }), f && (u = f, s = s.replace(r, "$1").replace(n, "0.$1")), c != s))
          return new h(s, u);
        if (h.DEBUG)
          throw Error(U + "Not a" + (f ? " base " + f : "") + " number: " + c);
        o.s = null;
      }
      o.c = o.e = null;
    };
  })();
  function F(e, r, n, l) {
    var t, o, c, i, f, u, s, a = e.c, m = pe;
    if (a) {
      e: {
        for (t = 1, i = a[0]; i >= 10; i /= 10, t++) ;
        if (o = r - t, o < 0)
          o += N, c = r, f = a[u = 0], s = q(f / m[t - c - 1] % 10);
        else if (u = ae((o + 1) / N), u >= a.length)
          if (l) {
            for (; a.length <= u; a.push(0)) ;
            f = s = 0, t = 1, o %= N, c = o - N + 1;
          } else
            break e;
        else {
          for (f = i = a[u], t = 1; i >= 10; i /= 10, t++) ;
          o %= N, c = o - N + t, s = c < 0 ? 0 : q(f / m[t - c - 1] % 10);
        }
        if (l = l || r < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        a[u + 1] != null || (c < 0 ? f : f % m[t - c - 1]), l = n < 4 ? (s || l) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || l || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (o > 0 ? c > 0 ? f / m[t - c] : 0 : a[u - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7)), r < 1 || !a[0])
          return a.length = 0, l ? (r -= e.e + 1, a[0] = m[(N - r % N) % N], e.e = -r || 0) : a[0] = e.e = 0, e;
        if (o == 0 ? (a.length = u, i = 1, u--) : (a.length = u + 1, i = m[N - o], a[u] = c > 0 ? q(f / m[t - c] % m[c]) * i : 0), l)
          for (; ; )
            if (u == 0) {
              for (o = 1, c = a[0]; c >= 10; c /= 10, o++) ;
              for (c = a[0] += i, i = 1; c >= 10; c /= 10, i++) ;
              o != i && (e.e++, a[0] == z && (a[0] = 1));
              break;
            } else {
              if (a[u] += i, a[u] != z) break;
              a[u--] = 0, i = 1;
            }
        for (o = a.length; a[--o] === 0; a.pop()) ;
      }
      e.e > $ ? e.c = e.e = null : e.e < Q && (e.c = [e.e = 0]);
    }
    return e;
  }
  function V(e) {
    var r, n = e.e;
    return n === null ? e.toString() : (r = y(e.c), r = n <= C || n >= k ? te(r, n) : W(r, n, "0"), e.s < 0 ? "-" + r : r);
  }
  return p.absoluteValue = p.abs = function() {
    var e = new h(this);
    return e.s < 0 && (e.s = 1), e;
  }, p.comparedTo = function(e, r) {
    return j(this, new h(e, r));
  }, p.decimalPlaces = p.dp = function(e, r) {
    var n, l, t, o = this;
    if (e != null)
      return x(e, 0, D), r == null ? r = I : x(r, 0, 8), F(new h(o), e + o.e + 1, r);
    if (!(n = o.c)) return null;
    if (l = ((t = n.length - 1) - X(this.e / N)) * N, t = n[t]) for (; t % 10 == 0; t /= 10, l--) ;
    return l < 0 && (l = 0), l;
  }, p.dividedBy = p.div = function(e, r) {
    return w(this, new h(e, r), _, I);
  }, p.dividedToIntegerBy = p.idiv = function(e, r) {
    return w(this, new h(e, r), 0, 1);
  }, p.exponentiatedBy = p.pow = function(e, r) {
    var n, l, t, o, c, i, f, u, s, a = this;
    if (e = new h(e), e.c && !e.isInteger())
      throw Error(U + "Exponent not an integer: " + V(e));
    if (r != null && (r = new h(r)), i = e.e > 14, !a.c || !a.c[0] || a.c[0] == 1 && !a.e && a.c.length == 1 || !e.c || !e.c[0])
      return s = new h(Math.pow(+V(a), i ? e.s * (2 - ie(e)) : +V(e))), r ? s.mod(r) : s;
    if (f = e.s < 0, r) {
      if (r.c ? !r.c[0] : !r.s) return new h(NaN);
      l = !f && a.isInteger() && r.isInteger(), l && (a = a.mod(r));
    } else {
      if (e.e > 9 && (a.e > 0 || a.e < -1 || (a.e == 0 ? a.c[0] > 1 || i && a.c[1] >= 24e7 : a.c[0] < 8e13 || i && a.c[0] <= 9999975e7)))
        return o = a.s < 0 && ie(e) ? -0 : 0, a.e > -1 && (o = 1 / o), new h(f ? 1 / o : o);
      Y && (o = ae(Y / N + 2));
    }
    for (i ? (n = new h(0.5), f && (e.s = 1), u = ie(e)) : (t = Math.abs(+V(e)), u = t % 2), s = new h(P); ; ) {
      if (u) {
        if (s = s.times(a), !s.c) break;
        o ? s.c.length > o && (s.c.length = o) : l && (s = s.mod(r));
      }
      if (t) {
        if (t = q(t / 2), t === 0) break;
        u = t % 2;
      } else if (e = e.times(n), F(e, e.e + 1, 1), e.e > 14)
        u = ie(e);
      else {
        if (t = +V(e), t === 0) break;
        u = t % 2;
      }
      a = a.times(a), o ? a.c && a.c.length > o && (a.c.length = o) : l && (a = a.mod(r));
    }
    return l ? s : (f && (s = P.div(s)), r ? s.mod(r) : o ? F(s, Y, I, c) : s);
  }, p.integerValue = function(e) {
    var r = new h(this);
    return e == null ? e = I : x(e, 0, 8), F(r, r.e + 1, e);
  }, p.isEqualTo = p.eq = function(e, r) {
    return j(this, new h(e, r)) === 0;
  }, p.isFinite = function() {
    return !!this.c;
  }, p.isGreaterThan = p.gt = function(e, r) {
    return j(this, new h(e, r)) > 0;
  }, p.isGreaterThanOrEqualTo = p.gte = function(e, r) {
    return (r = j(this, new h(e, r))) === 1 || r === 0;
  }, p.isInteger = function() {
    return !!this.c && X(this.e / N) > this.c.length - 2;
  }, p.isLessThan = p.lt = function(e, r) {
    return j(this, new h(e, r)) < 0;
  }, p.isLessThanOrEqualTo = p.lte = function(e, r) {
    return (r = j(this, new h(e, r))) === -1 || r === 0;
  }, p.isNaN = function() {
    return !this.s;
  }, p.isNegative = function() {
    return this.s < 0;
  }, p.isPositive = function() {
    return this.s > 0;
  }, p.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, p.minus = function(e, r) {
    var n, l, t, o, c = this, i = c.s;
    if (e = new h(e, r), r = e.s, !i || !r) return new h(NaN);
    if (i != r)
      return e.s = -r, c.plus(e);
    var f = c.e / N, u = e.e / N, s = c.c, a = e.c;
    if (!f || !u) {
      if (!s || !a) return s ? (e.s = -r, e) : new h(a ? c : NaN);
      if (!s[0] || !a[0])
        return a[0] ? (e.s = -r, e) : new h(s[0] ? c : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          I == 3 ? -0 : 0
        ));
    }
    if (f = X(f), u = X(u), s = s.slice(), i = f - u) {
      for ((o = i < 0) ? (i = -i, t = s) : (u = f, t = a), t.reverse(), r = i; r--; t.push(0)) ;
      t.reverse();
    } else
      for (l = (o = (i = s.length) < (r = a.length)) ? i : r, i = r = 0; r < l; r++)
        if (s[r] != a[r]) {
          o = s[r] < a[r];
          break;
        }
    if (o && (t = s, s = a, a = t, e.s = -e.s), r = (l = a.length) - (n = s.length), r > 0) for (; r--; s[n++] = 0) ;
    for (r = z - 1; l > i; ) {
      if (s[--l] < a[l]) {
        for (n = l; n && !s[--n]; s[n] = r) ;
        --s[n], s[l] += z;
      }
      s[l] -= a[l];
    }
    for (; s[0] == 0; s.splice(0, 1), --u) ;
    return s[0] ? le(e, s, u) : (e.s = I == 3 ? -1 : 1, e.c = [e.e = 0], e);
  }, p.modulo = p.mod = function(e, r) {
    var n, l, t = this;
    return e = new h(e, r), !t.c || !e.s || e.c && !e.c[0] ? new h(NaN) : !e.c || t.c && !t.c[0] ? new h(t) : (ee == 9 ? (l = e.s, e.s = 1, n = w(t, e, 0, 3), e.s = l, n.s *= l) : n = w(t, e, 0, ee), e = t.minus(n.times(e)), !e.c[0] && ee == 1 && (e.s = t.s), e);
  }, p.multipliedBy = p.times = function(e, r) {
    var n, l, t, o, c, i, f, u, s, a, m, E, A, T, R, d = this, v = d.c, M = (e = new h(e, r)).c;
    if (!v || !M || !v[0] || !M[0])
      return !d.s || !e.s || v && !v[0] && !M || M && !M[0] && !v ? e.c = e.e = e.s = null : (e.s *= d.s, !v || !M ? e.c = e.e = null : (e.c = [0], e.e = 0)), e;
    for (l = X(d.e / N) + X(e.e / N), e.s *= d.s, f = v.length, a = M.length, f < a && (A = v, v = M, M = A, t = f, f = a, a = t), t = f + a, A = []; t--; A.push(0)) ;
    for (T = z, R = J, t = a; --t >= 0; ) {
      for (n = 0, m = M[t] % R, E = M[t] / R | 0, c = f, o = t + c; o > t; )
        u = v[--c] % R, s = v[c] / R | 0, i = E * u + s * m, u = m * u + i % R * R + A[o] + n, n = (u / T | 0) + (i / R | 0) + E * s, A[o--] = u % T;
      A[o] = n;
    }
    return n ? ++l : A.splice(0, 1), le(e, A, l);
  }, p.negated = function() {
    var e = new h(this);
    return e.s = -e.s || null, e;
  }, p.plus = function(e, r) {
    var n, l = this, t = l.s;
    if (e = new h(e, r), r = e.s, !t || !r) return new h(NaN);
    if (t != r)
      return e.s = -r, l.minus(e);
    var o = l.e / N, c = e.e / N, i = l.c, f = e.c;
    if (!o || !c) {
      if (!i || !f) return new h(t / 0);
      if (!i[0] || !f[0]) return f[0] ? e : new h(i[0] ? l : t * 0);
    }
    if (o = X(o), c = X(c), i = i.slice(), t = o - c) {
      for (t > 0 ? (c = o, n = f) : (t = -t, n = i), n.reverse(); t--; n.push(0)) ;
      n.reverse();
    }
    for (t = i.length, r = f.length, t - r < 0 && (n = f, f = i, i = n, r = t), t = 0; r; )
      t = (i[--r] = i[r] + f[r] + t) / z | 0, i[r] = z === i[r] ? 0 : i[r] % z;
    return t && (i = [t].concat(i), ++c), le(e, i, c);
  }, p.precision = p.sd = function(e, r) {
    var n, l, t, o = this;
    if (e != null && e !== !!e)
      return x(e, 1, D), r == null ? r = I : x(r, 0, 8), F(new h(o), e, r);
    if (!(n = o.c)) return null;
    if (t = n.length - 1, l = t * N + 1, t = n[t]) {
      for (; t % 10 == 0; t /= 10, l--) ;
      for (t = n[0]; t >= 10; t /= 10, l++) ;
    }
    return e && o.e + 1 > l && (l = o.e + 1), l;
  }, p.shiftedBy = function(e) {
    return x(e, -he, he), this.times("1e" + e);
  }, p.squareRoot = p.sqrt = function() {
    var e, r, n, l, t, o = this, c = o.c, i = o.s, f = o.e, u = _ + 4, s = new h("0.5");
    if (i !== 1 || !c || !c[0])
      return new h(!i || i < 0 && (!c || c[0]) ? NaN : c ? o : 1 / 0);
    if (i = Math.sqrt(+V(o)), i == 0 || i == 1 / 0 ? (r = y(c), (r.length + f) % 2 == 0 && (r += "0"), i = Math.sqrt(+r), f = X((f + 1) / 2) - (f < 0 || f % 2), i == 1 / 0 ? r = "5e" + f : (r = i.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + f), n = new h(r)) : n = new h(i + ""), n.c[0]) {
      for (f = n.e, i = f + u, i < 3 && (i = 0); ; )
        if (t = n, n = s.times(t.plus(w(o, t, u, 1))), y(t.c).slice(0, i) === (r = y(n.c)).slice(0, i))
          if (n.e < f && --i, r = r.slice(i - 3, i + 1), r == "9999" || !l && r == "4999") {
            if (!l && (F(t, t.e + _ + 2, 0), t.times(t).eq(o))) {
              n = t;
              break;
            }
            u += 4, i += 4, l = 1;
          } else {
            (!+r || !+r.slice(1) && r.charAt(0) == "5") && (F(n, n.e + _ + 2, 1), e = !n.times(n).eq(o));
            break;
          }
    }
    return F(n, n.e + _ + 1, I, e);
  }, p.toExponential = function(e, r) {
    return e != null && (x(e, 0, D), e++), se(this, e, r, 1);
  }, p.toFixed = function(e, r) {
    return e != null && (x(e, 0, D), e = e + this.e + 1), se(this, e, r);
  }, p.toFormat = function(e, r, n) {
    var l, t = this;
    if (n == null)
      e != null && r && typeof r == "object" ? (n = r, r = null) : e && typeof e == "object" ? (n = e, e = r = null) : n = fe;
    else if (typeof n != "object")
      throw Error(U + "Argument not an object: " + n);
    if (l = t.toFixed(e, r), t.c) {
      var o, c = l.split("."), i = +n.groupSize, f = +n.secondaryGroupSize, u = n.groupSeparator || "", s = c[0], a = c[1], m = t.s < 0, E = m ? s.slice(1) : s, A = E.length;
      if (f && (o = i, i = f, f = o, A -= o), i > 0 && A > 0) {
        for (o = A % i || i, s = E.substr(0, o); o < A; o += i) s += u + E.substr(o, i);
        f > 0 && (s += u + E.slice(o)), m && (s = "-" + s);
      }
      l = a ? s + (n.decimalSeparator || "") + ((f = +n.fractionGroupSize) ? a.replace(
        new RegExp("\\d{" + f + "}\\B", "g"),
        "$&" + (n.fractionGroupSeparator || "")
      ) : a) : s;
    }
    return (n.prefix || "") + l + (n.suffix || "");
  }, p.toFraction = function(e) {
    var r, n, l, t, o, c, i, f, u, s, a, m, E = this, A = E.c;
    if (e != null && (i = new h(e), !i.isInteger() && (i.c || i.s !== 1) || i.lt(P)))
      throw Error(U + "Argument " + (i.isInteger() ? "out of range: " : "not an integer: ") + V(i));
    if (!A) return new h(E);
    for (r = new h(P), u = n = new h(P), l = f = new h(P), m = y(A), o = r.e = m.length - E.e - 1, r.c[0] = pe[(c = o % N) < 0 ? N + c : c], e = !e || i.comparedTo(r) > 0 ? o > 0 ? r : u : i, c = $, $ = 1 / 0, i = new h(m), f.c[0] = 0; s = w(i, r, 0, 1), t = n.plus(s.times(l)), t.comparedTo(e) != 1; )
      n = l, l = t, u = f.plus(s.times(t = u)), f = t, r = i.minus(s.times(t = r)), i = t;
    return t = w(e.minus(n), l, 0, 1), f = f.plus(t.times(u)), n = n.plus(t.times(l)), f.s = u.s = E.s, o = o * 2, a = w(u, l, o, I).minus(E).abs().comparedTo(
      w(f, n, o, I).minus(E).abs()
    ) < 1 ? [u, l] : [f, n], $ = c, a;
  }, p.toNumber = function() {
    return +V(this);
  }, p.toPrecision = function(e, r) {
    return e != null && x(e, 1, D), se(this, e, r, 2);
  }, p.toString = function(e) {
    var r, n = this, l = n.s, t = n.e;
    return t === null ? l ? (r = "Infinity", l < 0 && (r = "-" + r)) : r = "NaN" : (e == null ? r = t <= C || t >= k ? te(y(n.c), t) : W(y(n.c), t, "0") : e === 10 && oe ? (n = F(new h(n), _ + t + 1, I), r = W(y(n.c), n.e, "0")) : (x(e, 2, K.length, "Base"), r = O(W(y(n.c), t, "0"), 10, e, l, !0)), l < 0 && n.c[0] && (r = "-" + r)), r;
  }, p.valueOf = p.toJSON = function() {
    return V(this);
  }, p._isBigNumber = !0, p[Symbol.toStringTag] = "BigNumber", p[Symbol.for("nodejs.util.inspect.custom")] = p.valueOf, g != null && h.set(g), h;
}
function X(g) {
  var w = g | 0;
  return g > 0 || g === w ? w : w - 1;
}
function y(g) {
  for (var w, O, S = 1, p = g.length, P = g[0] + ""; S < p; ) {
    for (w = g[S++] + "", O = N - w.length; O--; w = "0" + w) ;
    P += w;
  }
  for (p = P.length; P.charCodeAt(--p) === 48; ) ;
  return P.slice(0, p + 1 || 1);
}
function j(g, w) {
  var O, S, p = g.c, P = w.c, _ = g.s, I = w.s, C = g.e, k = w.e;
  if (!_ || !I) return null;
  if (O = p && !p[0], S = P && !P[0], O || S) return O ? S ? 0 : -I : _;
  if (_ != I) return _;
  if (O = _ < 0, S = C == k, !p || !P) return S ? 0 : !p ^ O ? 1 : -1;
  if (!S) return C > k ^ O ? 1 : -1;
  for (I = (C = p.length) < (k = P.length) ? C : k, _ = 0; _ < I; _++) if (p[_] != P[_]) return p[_] > P[_] ^ O ? 1 : -1;
  return C == k ? 0 : C > k ^ O ? 1 : -1;
}
function x(g, w, O, S) {
  if (g < w || g > O || g !== q(g))
    throw Error(U + (S || "Argument") + (typeof g == "number" ? g < w || g > O ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(g));
}
function ie(g) {
  var w = g.c.length - 1;
  return X(g.e / N) == w && g.c[w] % 2 != 0;
}
function te(g, w) {
  return (g.length > 1 ? g.charAt(0) + "." + g.slice(1) : g) + (w < 0 ? "e" : "e+") + w;
}
function W(g, w, O) {
  var S, p;
  if (w < 0) {
    for (p = O + "."; ++w; p += O) ;
    g = p + g;
  } else if (S = g.length, ++w > S) {
    for (p = O, w -= S; --w; p += O) ;
    g += p;
  } else w < S && (g = g.slice(0, w) + "." + g.slice(w));
  return g;
}
var Be = Oe();
const Pe = (g) => typeof g != "object" || Array.isArray(g) || g === null ? {} : Object.fromEntries(
  Object.entries(g).map(([w, O]) => [
    w,
    Be.isBigNumber(O) ? O.toString() : O
  ])
);
Ne.use(xe).use(_e);
const Re = Ne, de = (g, w, O) => Re.t(g, {
  ...Pe(w),
  nsSeparator: ":::",
  ns: "translation",
  interpolation: { escapeValue: !0, alwaysFormat: !0 }
}), ye = ({
  projectName: g,
  pageTitle: w
}) => {
  b(() => {
    let O = w ? de("page-title-with-separator", { title: w }) : "";
    O += g, document.title = O;
  }, [g, w]);
};
function qe(g) {
  b(() => {
    if (!g) return;
    const w = (O) => (O.preventDefault(), O.returnValue = !0, de("common.unsaved-changes"));
    return window.addEventListener("beforeunload", w), () => window.removeEventListener("beforeunload", w);
  }, [g]);
}
export {
  Fe as useIsInPast,
  ye as usePageTitle,
  qe as usePreventWindowUnload,
  Ge as useScrollToTop,
  Ie as useTimeout
};
//# sourceMappingURL=index.js.map
